//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";

// component
import Header from "../../component/common/Header";
import Product from "./components/Product";
import Footer from "../../component/common/Footer";
import InnerCon from "../../component/layouts/InnerCon";

// responsive
import { M, T } from "../../utils/MT";

export default function ProductPage() {
    return (
        <Wrap>
            <Header />
            <InnerCon>
                <Product />
            </InnerCon>
            <Footer />
        </Wrap>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;
`;
